const isObjectEmpty = (obj: any) => {
  return obj !== null && obj !== undefined && Object.keys(obj).length === 0 && obj.constructor === Object;
};

const capitalizeString = (string = "") => {
  return string?.charAt(0).toUpperCase() + string?.substring(1).toLowerCase();
};

export { isObjectEmpty, capitalizeString };
